import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';
import { ActionTypes } from '../../utils/enums';

const TitleComponent = props => <Title>{props.title}</Title>;

TitleComponent.propTypes = {
    title: PropTypes.string.isRequired
};

const ElectionReminderSuccess = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            fullWidth
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent title={props.title} />}
            hideSubtitle={true}
            {...props}
        />
    </TransitionContainerNoExit>
);

ElectionReminderSuccess.propTypes = {
    thankYouText: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};

export default connect(
    () => ({
        title: `You're now signed up to receive reminders for upcoming elections.`,
        thankYouText: `You'll be getting emails in advance of major electoral events such as your state primaries and general elections. Make your voice heard.`
    }),
    {},
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.ElectionReminder)
                return true;

            return next === prev;
        }
    }
)(ElectionReminderSuccess);
